export default "__VITE_ASSET__BGgq4o2S__"